<div id="layoutFooter" [class]="!isDesktop ? 'web-center' : ''" *ngIf="footer_enabled">
    <div id="footer-container">
        <div class="footer-links-box">
            <div class="pt-5" class="logo-container">
                <img src="assets/images/Logo-white.png" style="height: 4rem;width: 16rem;object-fit: contain;cursor: pointer;" (click)="goToHome()"/>
            </div>
            <div class="show-social-upper">
                <app-social-media-bar/>
            </div>
            <div class="menu-links-container">
                <ul class="horizontal-menu four-column-menu">
                    <li class="fs-6 text-white" *ngFor="let item of menuItemKeys" (click)="onItemClick(item)">
                        <span class="fm-rubik page-links" style="font-size: 1.143rem;font-weight: 400;">
                            {{ item }}
                        </span>
                    </li>
                </ul>
            </div>
            <div class="pt-4 d-flex show-social-bottom">
                <app-social-media-bar/>    
            </div>
        </div>
        <div class="text-white web-center" style="margin-top: 25px;">
            <p style="font-size: smaller">NutriGenic &copy; {{ currentYear }}. <span style="color: lightgray">All rights reserved. </span></p>
        </div>
    </div>
</div>

